import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export default function FlipCard({
  currentNumber,
  nextNumber,
}: {
  currentNumber: number;
  nextNumber: number;
}) {
  const [displayedNumber, setDisplayedNumber] = useState(currentNumber);
  const [isAnimating, setIsAnimating] = useState(false);
  const FLIP_DURATION_MS = 600;

  useEffect(() => {
    setIsAnimating(true);
    const timeoutId = setTimeout(() => {
      setDisplayedNumber(nextNumber);
      setIsAnimating(false);
    }, FLIP_DURATION_MS);

    return () => clearTimeout(timeoutId);
  }, [nextNumber]);

  return (
    <div className="relative w-8 h-12 perspective text-white">
      {/* Bottom full card (final state) */}
      <div className="absolute inset-0 z-0 flex items-center justify-center text-2xl font-bold bg-zinc-900 border border-zinc-700 rounded-md shadow">
        {isAnimating ? currentNumber : displayedNumber}
      </div>

      {/* Flipping top half */}
      <AnimatePresence initial={false}>
        {isAnimating && (
          <motion.div
            key="flip"
            className="absolute inset-0 z-10 overflow-hidden origin-top"
            initial={{ rotateX: 90 }}
            animate={{ rotateX: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
            style={{
              transformStyle: "preserve-3d",
              backfaceVisibility: "hidden",
            }}
          >
            <div className="absolute inset-0 flex items-center justify-center text-2xl font-bold bg-zinc-900 border border-zinc-500 rounded-md shadow">
              {isAnimating ? nextNumber : displayedNumber}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
